// Helper function to convert text with newlines to React elements with <br /> tags
import React, { ReactNode } from 'react'

export const textWithLineBreaks = (text: string): ReactNode => {
  return text.split('\n').map((line, index, array) => (
    <React.Fragment key={index}>
      {line}
  {index < array.length - 1 && <br />}
  </React.Fragment>
))
}